import { IconName } from '@frontend/icons';
import { theme } from '@frontend/theme';

export const OPERATORY_COLORS = [
  theme.colors.critical20,
  theme.colors.rose20,
  theme.colors.secondary.eggplant20,
  theme.colors.indigo20,
  theme.colors.primary20,
  theme.colors.secondary.seaweed20,
  theme.colors.warning10,
  theme.colors.tangerine20,
  theme.colors.neutral20,
];

export const OPERATORY_COUNT_ICONS: IconName[] = [
  'count-one',
  'count-two',
  'count-three',
  'count-four',
  'count-five',
  'count-six',
  'count-seven',
  'count-eight',
  'count-nine',
  'count-zero',
];

export const OPERATORY_ALL_ICONS: IconName[] = [
  'computer',
  'building',
  'star',
  'moon',
  'like',
  'crown',
  'analytics-info',
  'wellness',
  'vet-bird',
  'vet-horse-small',
  'vet-reptile',
  'vet-rodent',
  'vet-cat',
  'vet-dog',
  'scissors',
  'bone',
  'broken-bone',
  'paw',
  'medical-stroke',
  'medical-filled',
  'heart-monitor',
  'tooth',
  'glasses',
  'camera',
  'emoji',
  'emoji-sad',
  ...OPERATORY_COUNT_ICONS,
];
